import callApi, { callApiPocketmoney } from '../../assets/api';
import { getWithExpiry, setWithExpiry } from '../../assets/utility';
import * as actionTypes from './actionTypes';
import { notify } from './notifyAction';
import { setUser, setUserLoading } from './userAction';

export const setStatus = data => {
  return {
    type: actionTypes.SET_STATUS,
    payload: data,
  };
};

export const childOtpVerified = data => {
  return {
    type: actionTypes.CHILD_OTP_VERIFIED,
    payload: data,
  };
};

export const setLoading = () => {
  return {
    type: actionTypes.SET_LOADING,
  };
};

export const setParentReset = data => {
  return {
    type: actionTypes.PARENT_RESET,
    payload: { ...data },
  };
};

export const createChildrenAction = data => {
  return {
    type: actionTypes.CREATE_CHILDREN_ACCOUNT,
    payload: data,
  };
};

export const parentLogin = data => {
  return {
    type: actionTypes.PARENT_LOGIN_STATUS,
    payload: data,
  };
};

export const childrenLogin = data => {
  return {
    type: actionTypes.CHILDREN_LOGIN_STATUS,
    payload: data,
  };
};

export const isLogIn = data => {
  return {
    type: actionTypes.IS_LOGGED_IN,
    payload: data,
  };
};

export const sendSignupOtp = (data, callBack) => {
  return (dispatch, getState) => {
    dispatch(setUserLoading({ sendOtp: true }));
    const requestBody = {
      email: data.email,
      ref: data.ref,
    };
    callApi('SignUp', 'POST', requestBody)
      .then(res => {
        const { status, successMessage, errorMessage, error } = res;
        callBack &&
          typeof callBack == 'function' &&
          callBack({
            otpSent: status,
            errorMessage,
          });
        if (status) {
          dispatch(notify(`OTP sent to ${requestBody.email}`, 'success'));
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
          }),
        );
        dispatch(setUserLoading({ sendOtp: false }));
      })
      .catch(err => {
        dispatch(notify(err?.response?.data?.errorMessage, 'error'));
        dispatch(
          setStatus({
            error: err?.response?.data?.error || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
            successMessage: err?.response?.data?.successMessage || '',
          }),
        );
        dispatch(setUserLoading({ sendOtp: false }));
      });
  };
};

export const confirmOTP = ({ email, otp }, callBack) => {
  //# HERE WE CREATE DYNMAIC ACTION DISPATCHER FOR ALL CASE'S
  return (dispatch, getState) => {
    dispatch(setUserLoading({ sendOtp: true }));
    //# HERE MAKE ASYNC CALLS.
    dispatch(setLoading());
    const reqBody = {
      email: email,
      otp: otp,
    };

    callApi('Confirm', 'POST', reqBody)
      .then(res => {
        const {
          status,
          successMessage,
          errorMessage,
          user,
          registered,
          error,
          token,
        } = res;

        callBack &&
          typeof callBack == 'function' &&
          callBack({
            user: user,
            registered: registered,
            otpVerified: status,
          });

        if (status) {
          let keysToRemove = ['email', 'timer'];
          keysToRemove.forEach(k => localStorage.removeItem(k));

          setWithExpiry(
            'childAccountToken',
            {
              user: user,
              registered: registered,
            },
            0.5 * 7, // 30min
          );
          localStorage.setItem('childToken', JSON.stringify(token));
          dispatch(notify('OTP Verified!', 'success'));
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
          }),
        );

        // successMessage && dispatch(notify(successMessage, "success"));
        // localStorage.removeItem("email");
        dispatch(setUserLoading({ sendOtp: false }));
      })
      .catch(err => {
        dispatch(
          setStatus({
            error: err?.response?.data?.error || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
        dispatch(
          notify(
            err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
            'error',
          ),
        );
        dispatch(setUserLoading({ sendOtp: false }));
      });
  };
};

export const createChildrenAccount = (data, callBack) => {
  return (dispatch, getState) => {
    dispatch(setUserLoading({ sendOtp: true }));
    dispatch(setLoading());
    const reqBody = data.user;

    callApi(
      'Register',
      'POST',
      reqBody,
      'application/json',
      false,
      'childToken',
    )
      .then(res => {
        const { status, successMessage, errorMessage, error } = res;
        if (typeof callBack == 'function') callBack({ status: status });
        if (status) {
          dispatch(notify(successMessage, 'success'));
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(setLoading());
        dispatch(
          createChildrenAction({
            registered: status,
          }),
        );
        dispatch(
          setStatus({
            registered: status,
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
          }),
        );
        dispatch(setUserLoading({ sendOtp: false }));
      })
      .catch(err => {
        let error =
          err?.response?.data || err || err?.response?.data?.errorMessage;
        dispatch(notify(error, 'error'));
        dispatch(
          setStatus({
            error: err?.response?.data?.error || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
            successMessage: err?.response?.data?.successMessage || '',
          }),
        );
        dispatch(setLoading());
        dispatch(setUserLoading({ sendOtp: false }));
      });
  };
};

export const parentLoginAction = user => {
  return (dispatch, getState) => {
    //# HERE MAKE ASYNC CALLS.
    dispatch(setUserLoading({ loginUser: true }));
    const reqBody = { ...user, channel: 'pm-website' };

    callApiPocketmoney('parentLogin', 'POST', reqBody)
      .then(res => {
        const { status, successMessage, errorMessage, token, user, error } =
          res;
        if (status) {
          setWithExpiry('token', token, 1);
          dispatch(
            setUser({
              user: user,
            }),
          );
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
          }),
        );
        dispatch(
          parentLogin({
            status: status,
          }),
        );
        dispatch(setUserLoading({ loginUser: false }));
      })
      .catch(err => {
        dispatch(
          notify(
            err?.response?.data?.errorMessage || err?.response?.data || err,
            'error',
          ),
        );
        dispatch(
          setStatus({
            error: err?.response?.data || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
        dispatch(setUserLoading({ loginUser: false }));
      });
  };
};

export const childrenLoginAction = user => {
  return (dispatch, getState) => {
    //# HERE MAKE ASYNC CALLS.
    dispatch(setUserLoading({ loginUser: true }));
    const reqBody = { ...user, channel: 'pm-website' };

    callApiPocketmoney('childrenLogin', 'POST', reqBody)
      .then(res => {
        const { status, successMessage, errorMessage, token, user, error } =
          res;
        if (status) {
          setWithExpiry('token', token, 1);
          dispatch(
            setUser({
              user: user,
            }),
          );
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          childrenLogin({
            status: status,
          }),
        );
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
          }),
        );
        dispatch(setUserLoading({ loginUser: false }));
      })
      .catch(err => {
        dispatch(
          notify(
            err?.response?.data?.errorMessage || err?.response?.data || err,
            'error',
          ),
        );
        dispatch(
          setStatus({
            error: err?.response?.data || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
        dispatch(setUserLoading({ loginUser: false }));
      });
  };
};

export const isLogInAsync = () => {
  //# HERE WE CREATE DYNMAIC ACTION DISPATCHER FOR ALL CASE'S
  return async (dispatch, getState) => {
    //# HERE MAKE ASYNC CALLS.
    let storedToken = getWithExpiry('token');
    const reqBody = {
      token: storedToken,
    };
    callApi('IsLoggedIn', 'POST', reqBody)
      .then(res => {
        const { status, message, error, user } = res;
        if (status) {
          dispatch(isLogIn({ status: status, user: user }));

          dispatch(
            setUser({
              user: user,
            }),
          );
        } else {
          dispatch(
            setUser({
              user: false,
            }),
          );
        }
      })
      .catch(err => {
        dispatch(isLogIn({ status: false }));
        dispatch(
          setStatus({
            error: err?.response?.data || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
      });
  };
};

export const forgotPassword = email => {
  //# HERE WE CREATE DYNMAIC ACTION DISPATCHER FOR ALL CASE'S

  return (dispatch, getState) => {
    //# HERE MAKE ASYNC CALLS.
    dispatch(setLoading());
    const reqBody = {
      email: email,
    };
    callApi('ForgotPassword', 'POST', reqBody)
      .then(res => {
        const { status, successMessage, errorMessage, error, token } = res;
        if (!status) {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
            verificationMailSent: !!status || !!token,
          }),
        );
      })
      .catch(err => {
        let error =
          err?.response?.data || err || err?.response?.data?.errorMessage;
        dispatch(notify(error, 'error'));
        dispatch(
          setStatus({
            error: err?.response?.data || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
      });
  };
};

export const confirmForgotPasswordOTP = ({ email, otp }) => {
  //# HERE WE CREATE DYNMAIC ACTION DISPATCHER FOR ALL CASE'S
  return (dispatch, getState) => {
    //# HERE MAKE ASYNC CALLS
    dispatch(setLoading());
    const reqBody = {
      email: email,
      otp: otp,
    };

    callApi('confirmForgotPasswordOtp', 'POST', reqBody)
      .then(res => {
        const { status, successMessage, errorMessage, error, token } = res;

        if (status) {
          localStorage.setItem('otp_token', token);
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
            otpVerified: !!status,
          }),
        );
      })
      .catch(err => {
        let error =
          err?.response?.data || err || err?.response?.data?.errorMessage;
        dispatch(notify(error, 'error'));
        dispatch(
          setStatus({
            error: err?.response?.data?.error || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
        // localStorage.removeItem("email");
      });
  };
};

export const resetPassword = ({ token, password }) => {
  //# HERE WE CREATE DYNMAIC ACTION DISPATCHER FOR ALL CASE'S

  return (dispatch, getState) => {
    //# HERE MAKE ASYNC CALLS.
    dispatch(setLoading());
    const reqBody = {
      token: token,
      password: password,
    };
    callApi('ResetPassword', 'POST', reqBody)
      .then(res => {
        const { status, successMessage, errorMessage, error } = res;
        if (status) {
          dispatch(notify(successMessage, 'success'));
        } else {
          dispatch(notify(errorMessage, 'error'));
        }
        dispatch(
          setStatus({
            error: error,
            successMessage: successMessage,
            errorMessage: errorMessage,
            isPasswordReset: true,
            verificationMailSent: false,
            otpVerified: false,
          }),
        );
      })
      .catch(err => {
        let error =
          err?.response?.data || err || err?.response?.data?.errorMessage;
        dispatch(notify(error, 'error'));
        dispatch(
          setStatus({
            error: err?.response?.data || err,
            errorMessage:
              err?.response?.data?.errorMessage ||
              'Please try again by refresh..!',
          }),
        );
      });
  };
};

export const refreshToken = () => {
  callApi('RefreshToken', 'POST', { channel: 'pm-website' })
    .then(res => {
      const { status, successMessage, errorMessage, error, token } = res;
      if (status) {
        setWithExpiry('token', token, 1);
      }
    })
    .catch(err => notify(err?.response?.data?.errorMessage, 'error'));
};